import { createFileRoute, redirect } from '@tanstack/react-router';
import { getUserState } from '@carvana/core-auth';
import { getRoutePath } from '@/utils/getRoutePath';

export const Route = createFileRoute('/_protected')({
  beforeLoad: ({ location }) => {
    if (!getUserState().isLoggedIn) {
      const returnUrl = encodeURIComponent(`${getRoutePath()}${location.href}`);
      redirect({
        href: `${process.env.BASE_URL}/?openAccountModal=signIn&ReturnUrl=${returnUrl}`,
        throw: true,
      });
    }
  },
});
